import utils from 'helpers/utils';
import logger from 'helpers/logger';
import ServiceStore from 'stores/service.store';
import constants from 'helpers/constants';
import {processCollection} from 'services/collection/collection.utils';

const path = utils.servicePath(import.meta.url);

export class CollectionService extends ServiceStore {
  constructor (app, callbacks) {
    logger.trace(`Starting module at: services/${path}`);

    super(path, app, {
      separateEntityData: true, // single item contain more info than the list
      process: (data, meta) => {
        // process
        if (meta?.context?.$store?.dataType !== constants.dataTypes.other) {
          if (utils.isArray(data)) {
            return data.map(processCollection);
          } else {
            return processCollection(data);
          }
        } else {
          return data;
        }
      }
    }, callbacks);
  }
}
